export default __webpack_public_path__ + "static/media/bg1.7a45fd17.jpg";